module.exports = __webpack_public_path__ + "static/media/clock.78acebf5.svg";